export class BusinessInfoModel {
  public currencyCode: string;

  constructor(params: BusinessInfoModel) {
    this.currencyCode = params.currencyCode;
  }

  public static fromCartV1(currencyCode: string) {
    return new BusinessInfoModel({
      currencyCode,
    });
  }
}
